import yup from '../../../config/yup';

export const blackboardWriterValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('blackboardWriter'),
  delayedRead: yup.boolean(),
  onError: yup.string(),
  connectionKey: yup.string(),
  format: yup.string(),
  properties: yup.object().shape({
    key: yup.string().transform((value) => value.trim()),
    secret: yup.string().transform((value) => value.trim()),
    path: yup
      .string()
      .required('Path is required')

      .transform((value) => value.trim()),
    httpMethod: yup
      .string()
      .oneOf(['GET', 'POST', 'PUT', 'DELETE'])
      .required('HTTP Method is required')

      .transform((value) => value.trim()),
    headers: yup.string().transform((value) => value.trim()),
    headersJson: yup.string().transform((value) => value.trim()),
    inputTemplateRef: yup.string().transform((value) => value.trim()),
  }),
});
